import React from "react";
import ObjectUtils from "util/ObjectUtils";
import { Input } from "components/bootstrap";
import { Select, TimeUnitInput } from "components/common";
class DnsAdapterFieldSet extends React.Component {
  constructor() {
    super(...arguments);
    this._onLookupTypeSelect = (id) => {
      const { config, updateConfig } = this.props;
      const newConfig = ObjectUtils.clone(config);
      newConfig.lookup_type = id;
      updateConfig(newConfig);
    };
    this.updateCacheTTLOverride = (value, unit, enabled) => {
      this._updateCacheTTLOverride(value, unit, enabled, "cache_ttl_override");
    };
    this._updateCacheTTLOverride = (value, unit, enabled, fieldPrefix) => {
      const { config, updateConfig } = this.props;
      const newConfig = ObjectUtils.clone(config);
      if (enabled && value) {
        newConfig[fieldPrefix] = enabled && value ? value : null;
        newConfig[`${fieldPrefix}_enabled`] = enabled;
      } else {
        newConfig[fieldPrefix] = null;
        newConfig[`${fieldPrefix}_enabled`] = false;
      }
      newConfig[`${fieldPrefix}_unit`] = enabled ? unit : null;
      updateConfig(newConfig);
    };
  }
  render() {
    const { config, handleFormEvent, validationMessage, validationState } = this.props;
    const lookupTypes = [
      { label: "Resolve hostname to IPv4 address (A)", value: "A" },
      { label: "Resolve hostname to IPv6 address (AAAA)", value: "AAAA" },
      { label: "Resolve hostname to IPv4 and IPv6 addresses (A and AAAA)", value: "A_AAAA" },
      { label: "Reverse lookup (PTR)", value: "PTR" },
      { label: "Text lookup (TXT)", value: "TXT" }
    ];
    return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
      Input,
      {
        label: "DNS Lookup Type",
        id: "lookup-type",
        required: true,
        autoFocus: true,
        help: "Select the type of DNS lookup to perform.",
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      },
      /* @__PURE__ */ React.createElement(
        Select,
        {
          placeholder: "Select the type of DNS lookup",
          clearable: false,
          options: lookupTypes,
          onChange: this._onLookupTypeSelect,
          value: config.lookup_type
        }
      )
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "text",
        id: "server_ips",
        name: "server_ips",
        label: "DNS Server IP Address",
        onChange: handleFormEvent,
        help: validationMessage("server_ips", "An optional comma-separated list of DNS server IP addresses."),
        bsStyle: validationState("server_ips"),
        value: config.server_ips,
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "number",
        id: "request_timeout",
        name: "request_timeout",
        label: "DNS Request Timeout",
        required: true,
        onChange: handleFormEvent,
        help: validationMessage("request_timeout", "DNS request timeout in milliseconds."),
        bsStyle: validationState("request_timeout"),
        value: config.request_timeout,
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      }
    ), /* @__PURE__ */ React.createElement(
      TimeUnitInput,
      {
        label: "Cache TTL Override",
        help: "If enabled, the cache TTL will be overridden with the specified value.",
        update: this.updateCacheTTLOverride,
        value: config.cache_ttl_override,
        unit: config.cache_ttl_override_unit || "MINUTES",
        units: ["MILLISECONDS", "SECONDS", "MINUTES", "HOURS", "DAYS"],
        enabled: config.cache_ttl_override_enabled,
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      }
    ));
  }
}
export default DnsAdapterFieldSet;
